__turbopack_context__.v({
  "changelog-title-stick": "styles-module__Oi5Oya__changelog-title-stick",
  "stickyTitle": "styles-module__Oi5Oya__stickyTitle",
  "stickyTitleFrame": "styles-module__Oi5Oya__stickyTitleFrame",
  "stickyTitleProgress": "styles-module__Oi5Oya__stickyTitleProgress",
  "stickyTitleText": "styles-module__Oi5Oya__stickyTitleText",
});
